import React, { FunctionComponent } from "react";

import {
  PdfDocument,
  PdfUploadEmptyData,
  PdfRender,
  usePdfPreviewLayout,
} from "./components";
import { UploadablePdfPreviewProps } from "./types";

import "./css/style.css";

export const UploadablePdfPreview: FunctionComponent<
  UploadablePdfPreviewProps
> = ({ downloadUrl, scale, onFileSelected, withHeader }) => {
  const { containerWidth } = usePdfPreviewLayout({ footerHeight: 66, headerHeight: withHeader });

  return (
    <PdfRender downloadUrl={downloadUrl} headerSize={withHeader}>
      {!downloadUrl ? (
        <PdfUploadEmptyData onFileSelected={onFileSelected} />
      ) : (
        <PdfDocument width={containerWidth} scale={scale} file={downloadUrl} />
      )}
    </PdfRender>
  );
};
